/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Opaque from "App/render/webgl/nodes/bins/opaque_bin";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import {mat4, vec3} from "gl-matrix";
import Pass from "App/render/webgl/passes/pass";
import WebGLContext from "App/web_gl_context";
import Factory from "App/render/webgl/nodes/bins/factory";
import {SkyBoxBinTypeName} from "App/render/webgl/nodes/bins/type_names";
import IScene from "js_interface/src/scene_interface";

export default
class SkyBox extends Opaque {

    public static TypeName: string = SkyBoxBinTypeName;
    private static _pgcTempHalfVec3: vec3 = vec3.fromValues(-0.5, -0.5, -0.5);

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph) {
        super(aSceneAPI, aRenderGraph);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): SkyBox {
        return new SkyBox(aSceneAPI, aRenderGraph);
    }

    public setUniforms(aRenderPass: Pass) {
        let view = aRenderPass.view;
        let shader: any = aRenderPass.getActiveShaderRenderable();
        let gl = (<WebGLContext>this._context).getWebGLRenderingContext();

        // send model view and model view projection matrix to shader
        let mvp = view.getCamera().getViewProjectionMatrix();

        // create only rotation matrix
        mvp[12] = 0;
        mvp[13] = 0;
        mvp[14] = 0;
        mvp[15] = 0;
        mat4.translate(mvp, mvp, SkyBox._pgcTempHalfVec3);

        gl.uniformMatrix4fv(shader.uniformLocations.u_view_projection, false, mvp);
    }
}

Factory.register(SkyBox);
